var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M624.195 80.7054C684.726 115.653 734.983 165.931 769.906 226.477L425.264 425.264L624.195 80.7054Z",
    fill: "url(#paint0_linear_90_25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M425.264 27.402C495.16 27.402 563.823 45.8154 624.34 80.7888L425.264 425.264L425.264 27.402Z",
    fill: "url(#paint1_linear_90_25)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M823.128 425.264C823.128 495.16 804.715 563.823 769.741 624.34L425.266 425.264H823.128Z",
    fill: "url(#paint2_linear_90_25)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M769.823 226.333C804.771 286.864 823.156 355.535 823.127 425.43L425.265 425.264L769.823 226.333Z",
    fill: "url(#paint3_linear_90_25)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M769.823 624.195C734.875 684.727 684.597 734.984 624.051 769.906L425.264 425.264L769.823 624.195Z",
    fill: "url(#paint4_linear_90_25)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M226.333 769.823C165.801 734.875 115.544 684.597 80.6218 624.051L425.264 425.264L226.333 769.823Z",
    fill: "url(#paint5_linear_90_25)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M425.264 823.127C355.368 823.127 286.706 804.713 226.189 769.74L425.264 425.264L425.264 823.127Z",
    fill: "url(#paint6_linear_90_25)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M624.196 769.823C563.665 804.771 494.995 823.156 425.099 823.126L425.265 425.264L624.196 769.823Z",
    fill: "url(#paint7_linear_90_25)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.334 80.7058C286.866 45.7579 355.536 27.3731 425.432 27.4024L425.265 425.265L226.334 80.7058Z",
    fill: "url(#paint8_linear_90_25)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7059 226.333C115.654 165.801 165.932 115.545 226.478 80.622L425.265 425.264L80.7059 226.333Z",
    fill: "url(#paint9_linear_90_25)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.402 425.265C27.402 355.369 45.8154 286.706 80.7887 226.189L425.264 425.265H27.402Z",
    fill: "url(#paint10_linear_90_25)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7042 624.196C45.7562 563.664 27.3715 494.994 27.4007 425.098L425.263 425.265L80.7042 624.196Z",
    fill: "url(#paint11_linear_90_25)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_25",
    x1: 519.974,
    y1: 195.636,
    x2: 704.566,
    y2: 330.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_25",
    x1: 392.472,
    y1: 179.045,
    x2: 619.661,
    y2: 203.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_25",
    x1: 676.416,
    y1: 416.36,
    x2: 602.934,
    y2: 634.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_25",
    x1: 638.315,
    y1: 291.977,
    x2: 683.765,
    y2: 517.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_90_25",
    x1: 647.218,
    y1: 543.128,
    x2: 474.494,
    y2: 695.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_90_25",
    x1: 330.553,
    y1: 654.893,
    x2: 145.961,
    y2: 520.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_90_25",
    x1: 434.169,
    y1: 676.415,
    x2: 215.994,
    y2: 602.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_90_25",
    x1: 576.774,
    y1: 622.1,
    x2: 367.863,
    y2: 714.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_90_25",
    x1: 273.757,
    y1: 228.429,
    x2: 482.667,
    y2: 135.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_90_25",
    x1: 203.279,
    y1: 325.453,
    x2: 376.035,
    y2: 155.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_90_25",
    x1: 139.842,
    y1: 509.166,
    x2: 251.119,
    y2: 214.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_90_25",
    x1: 212.213,
    y1: 558.551,
    x2: 166.762,
    y2: 332.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors12);
export default __webpack_public_path__ + "static/media/sectors-12.20a04f053382e9dda043d775d274bada.svg";
export { ForwardRef as ReactComponent };